<script lang="ts">
    import { content, language } from "../../../store"
    import Row from "./Row.svelte"
</script>

{#each Object.entries($content) as row, i (i)}
    {#if row[0] != "additional" && row[1][0].language == $language }
        <Row row="{row}" i="{i}" />
    {/if}
{/each}

<style lang="less">
    @import "../../assets/css/variables.less";
</style>
